export enum AppraisalTemplateType {
  Standard = 0,
  Leader = 1,
  Project = 2
}
